// src/graphql/graphql.ts
var Audio_Tags_Constraint = /* @__PURE__ */ ((Audio_Tags_Constraint2) => {
  Audio_Tags_Constraint2["AudioTagsPkey"] = "audio_tags_pkey";
  return Audio_Tags_Constraint2;
})(Audio_Tags_Constraint || {});
var Audio_Tags_Select_Column = /* @__PURE__ */ ((Audio_Tags_Select_Column2) => {
  Audio_Tags_Select_Column2["AudioId"] = "audio_id";
  Audio_Tags_Select_Column2["CreatedAt"] = "created_at";
  Audio_Tags_Select_Column2["TagId"] = "tag_id";
  Audio_Tags_Select_Column2["UpdatedAt"] = "updated_at";
  return Audio_Tags_Select_Column2;
})(Audio_Tags_Select_Column || {});
var Audio_Tags_Update_Column = /* @__PURE__ */ ((Audio_Tags_Update_Column2) => {
  Audio_Tags_Update_Column2["AudioId"] = "audio_id";
  Audio_Tags_Update_Column2["CreatedAt"] = "created_at";
  Audio_Tags_Update_Column2["TagId"] = "tag_id";
  Audio_Tags_Update_Column2["UpdatedAt"] = "updated_at";
  return Audio_Tags_Update_Column2;
})(Audio_Tags_Update_Column || {});
var Audios_Constraint = /* @__PURE__ */ ((Audios_Constraint2) => {
  Audios_Constraint2["AudiosPkey"] = "audios_pkey";
  return Audios_Constraint2;
})(Audios_Constraint || {});
var Audios_Select_Column = /* @__PURE__ */ ((Audios_Select_Column2) => {
  Audios_Select_Column2["ArtistName"] = "artistName";
  Audios_Select_Column2["CreatedAt"] = "createdAt";
  Audios_Select_Column2["Id"] = "id";
  Audios_Select_Column2["Name"] = "name";
  Audios_Select_Column2["Public"] = "public";
  Audios_Select_Column2["Source"] = "source";
  Audios_Select_Column2["ThumbnailUrl"] = "thumbnailUrl";
  Audios_Select_Column2["UpdatedAt"] = "updatedAt";
  Audios_Select_Column2["UserId"] = "user_id";
  return Audios_Select_Column2;
})(Audios_Select_Column || {});
var Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = /* @__PURE__ */ ((Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2) => {
  Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["Public"] = "public";
  return Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2;
})(Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || {});
var Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = /* @__PURE__ */ ((Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2) => {
  Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["Public"] = "public";
  return Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2;
})(Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || {});
var Audios_Update_Column = /* @__PURE__ */ ((Audios_Update_Column2) => {
  Audios_Update_Column2["ArtistName"] = "artistName";
  Audios_Update_Column2["CreatedAt"] = "createdAt";
  Audios_Update_Column2["Id"] = "id";
  Audios_Update_Column2["Name"] = "name";
  Audios_Update_Column2["Public"] = "public";
  Audios_Update_Column2["Source"] = "source";
  Audios_Update_Column2["ThumbnailUrl"] = "thumbnailUrl";
  Audios_Update_Column2["UpdatedAt"] = "updatedAt";
  Audios_Update_Column2["UserId"] = "user_id";
  return Audios_Update_Column2;
})(Audios_Update_Column || {});
var Crawl_Requests_Constraint = /* @__PURE__ */ ((Crawl_Requests_Constraint2) => {
  Crawl_Requests_Constraint2["CrawlRequestsPkey"] = "crawl_requests_pkey";
  return Crawl_Requests_Constraint2;
})(Crawl_Requests_Constraint || {});
var Crawl_Requests_Select_Column = /* @__PURE__ */ ((Crawl_Requests_Select_Column2) => {
  Crawl_Requests_Select_Column2["CreatedAt"] = "created_at";
  Crawl_Requests_Select_Column2["GetSingleVideo"] = "get_single_video";
  Crawl_Requests_Select_Column2["Id"] = "id";
  Crawl_Requests_Select_Column2["Site"] = "site";
  Crawl_Requests_Select_Column2["SlugPrefix"] = "slug_prefix";
  Crawl_Requests_Select_Column2["Title"] = "title";
  Crawl_Requests_Select_Column2["UpdatedAt"] = "updated_at";
  Crawl_Requests_Select_Column2["Url"] = "url";
  Crawl_Requests_Select_Column2["UserId"] = "user_id";
  return Crawl_Requests_Select_Column2;
})(Crawl_Requests_Select_Column || {});
var Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = /* @__PURE__ */ ((Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2) => {
  Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["GetSingleVideo"] = "get_single_video";
  return Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2;
})(Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || {});
var Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = /* @__PURE__ */ ((Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2) => {
  Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["GetSingleVideo"] = "get_single_video";
  return Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2;
})(Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || {});
var Crawl_Requests_Update_Column = /* @__PURE__ */ ((Crawl_Requests_Update_Column2) => {
  Crawl_Requests_Update_Column2["CreatedAt"] = "created_at";
  Crawl_Requests_Update_Column2["GetSingleVideo"] = "get_single_video";
  Crawl_Requests_Update_Column2["Id"] = "id";
  Crawl_Requests_Update_Column2["Site"] = "site";
  Crawl_Requests_Update_Column2["SlugPrefix"] = "slug_prefix";
  Crawl_Requests_Update_Column2["Title"] = "title";
  Crawl_Requests_Update_Column2["UpdatedAt"] = "updated_at";
  Crawl_Requests_Update_Column2["Url"] = "url";
  Crawl_Requests_Update_Column2["UserId"] = "user_id";
  return Crawl_Requests_Update_Column2;
})(Crawl_Requests_Update_Column || {});
var Cursor_Ordering = /* @__PURE__ */ ((Cursor_Ordering2) => {
  Cursor_Ordering2["Asc"] = "ASC";
  Cursor_Ordering2["Desc"] = "DESC";
  return Cursor_Ordering2;
})(Cursor_Ordering || {});
var Feature_Flag_Constraint = /* @__PURE__ */ ((Feature_Flag_Constraint2) => {
  Feature_Flag_Constraint2["FeatureFlagPkey"] = "feature_flag_pkey";
  Feature_Flag_Constraint2["FeatureFlagSiteNameKey"] = "feature_flag_site_name_key";
  return Feature_Flag_Constraint2;
})(Feature_Flag_Constraint || {});
var Feature_Flag_Select_Column = /* @__PURE__ */ ((Feature_Flag_Select_Column2) => {
  Feature_Flag_Select_Column2["Conditions"] = "conditions";
  Feature_Flag_Select_Column2["CreatedAt"] = "created_at";
  Feature_Flag_Select_Column2["Description"] = "description";
  Feature_Flag_Select_Column2["Id"] = "id";
  Feature_Flag_Select_Column2["Name"] = "name";
  Feature_Flag_Select_Column2["RequireAuth"] = "require_auth";
  Feature_Flag_Select_Column2["Site"] = "site";
  Feature_Flag_Select_Column2["UpdatedAt"] = "updated_at";
  return Feature_Flag_Select_Column2;
})(Feature_Flag_Select_Column || {});
var Feature_Flag_Update_Column = /* @__PURE__ */ ((Feature_Flag_Update_Column2) => {
  Feature_Flag_Update_Column2["Conditions"] = "conditions";
  Feature_Flag_Update_Column2["CreatedAt"] = "created_at";
  Feature_Flag_Update_Column2["Description"] = "description";
  Feature_Flag_Update_Column2["Id"] = "id";
  Feature_Flag_Update_Column2["Name"] = "name";
  Feature_Flag_Update_Column2["RequireAuth"] = "require_auth";
  Feature_Flag_Update_Column2["Site"] = "site";
  Feature_Flag_Update_Column2["UpdatedAt"] = "updated_at";
  return Feature_Flag_Update_Column2;
})(Feature_Flag_Update_Column || {});
var Finance_Transactions_Constraint = /* @__PURE__ */ ((Finance_Transactions_Constraint2) => {
  Finance_Transactions_Constraint2["FinanceTransactionsPkey"] = "finance_transactions_pkey";
  return Finance_Transactions_Constraint2;
})(Finance_Transactions_Constraint || {});
var Finance_Transactions_Select_Column = /* @__PURE__ */ ((Finance_Transactions_Select_Column2) => {
  Finance_Transactions_Select_Column2["Amount"] = "amount";
  Finance_Transactions_Select_Column2["Category"] = "category";
  Finance_Transactions_Select_Column2["CreatedAt"] = "createdAt";
  Finance_Transactions_Select_Column2["Id"] = "id";
  Finance_Transactions_Select_Column2["Month"] = "month";
  Finance_Transactions_Select_Column2["Name"] = "name";
  Finance_Transactions_Select_Column2["Note"] = "note";
  Finance_Transactions_Select_Column2["UpdatedAt"] = "updatedAt";
  Finance_Transactions_Select_Column2["UserId"] = "user_id";
  Finance_Transactions_Select_Column2["Year"] = "year";
  return Finance_Transactions_Select_Column2;
})(Finance_Transactions_Select_Column || {});
var Finance_Transactions_Update_Column = /* @__PURE__ */ ((Finance_Transactions_Update_Column2) => {
  Finance_Transactions_Update_Column2["Amount"] = "amount";
  Finance_Transactions_Update_Column2["Category"] = "category";
  Finance_Transactions_Update_Column2["CreatedAt"] = "createdAt";
  Finance_Transactions_Update_Column2["Id"] = "id";
  Finance_Transactions_Update_Column2["Month"] = "month";
  Finance_Transactions_Update_Column2["Name"] = "name";
  Finance_Transactions_Update_Column2["Note"] = "note";
  Finance_Transactions_Update_Column2["UpdatedAt"] = "updatedAt";
  Finance_Transactions_Update_Column2["UserId"] = "user_id";
  Finance_Transactions_Update_Column2["Year"] = "year";
  return Finance_Transactions_Update_Column2;
})(Finance_Transactions_Update_Column || {});
var Journals_Constraint = /* @__PURE__ */ ((Journals_Constraint2) => {
  Journals_Constraint2["JournalsPkey"] = "journals_pkey";
  return Journals_Constraint2;
})(Journals_Constraint || {});
var Journals_Select_Column = /* @__PURE__ */ ((Journals_Select_Column2) => {
  Journals_Select_Column2["Content"] = "content";
  Journals_Select_Column2["CreatedAt"] = "createdAt";
  Journals_Select_Column2["Date"] = "date";
  Journals_Select_Column2["Id"] = "id";
  Journals_Select_Column2["Mood"] = "mood";
  Journals_Select_Column2["Tags"] = "tags";
  Journals_Select_Column2["UpdatedAt"] = "updatedAt";
  Journals_Select_Column2["UserId"] = "user_id";
  return Journals_Select_Column2;
})(Journals_Select_Column || {});
var Journals_Update_Column = /* @__PURE__ */ ((Journals_Update_Column2) => {
  Journals_Update_Column2["Content"] = "content";
  Journals_Update_Column2["CreatedAt"] = "createdAt";
  Journals_Update_Column2["Date"] = "date";
  Journals_Update_Column2["Id"] = "id";
  Journals_Update_Column2["Mood"] = "mood";
  Journals_Update_Column2["Tags"] = "tags";
  Journals_Update_Column2["UpdatedAt"] = "updatedAt";
  Journals_Update_Column2["UserId"] = "user_id";
  return Journals_Update_Column2;
})(Journals_Update_Column || {});
var Notifications_Constraint = /* @__PURE__ */ ((Notifications_Constraint2) => {
  Notifications_Constraint2["NotificationsPkey"] = "notifications_pkey";
  return Notifications_Constraint2;
})(Notifications_Constraint || {});
var Notifications_Select_Column = /* @__PURE__ */ ((Notifications_Select_Column2) => {
  Notifications_Select_Column2["CreatedAt"] = "createdAt";
  Notifications_Select_Column2["EntityId"] = "entityId";
  Notifications_Select_Column2["EntityType"] = "entityType";
  Notifications_Select_Column2["Id"] = "id";
  Notifications_Select_Column2["Link"] = "link";
  Notifications_Select_Column2["Metadata"] = "metadata";
  Notifications_Select_Column2["ReadAt"] = "readAt";
  Notifications_Select_Column2["Type"] = "type";
  Notifications_Select_Column2["UpdatedAt"] = "updatedAt";
  Notifications_Select_Column2["UserId"] = "user_id";
  return Notifications_Select_Column2;
})(Notifications_Select_Column || {});
var Notifications_Update_Column = /* @__PURE__ */ ((Notifications_Update_Column2) => {
  Notifications_Update_Column2["CreatedAt"] = "createdAt";
  Notifications_Update_Column2["EntityId"] = "entityId";
  Notifications_Update_Column2["EntityType"] = "entityType";
  Notifications_Update_Column2["Id"] = "id";
  Notifications_Update_Column2["Link"] = "link";
  Notifications_Update_Column2["Metadata"] = "metadata";
  Notifications_Update_Column2["ReadAt"] = "readAt";
  Notifications_Update_Column2["Type"] = "type";
  Notifications_Update_Column2["UpdatedAt"] = "updatedAt";
  Notifications_Update_Column2["UserId"] = "user_id";
  return Notifications_Update_Column2;
})(Notifications_Update_Column || {});
var Order_By = /* @__PURE__ */ ((Order_By2) => {
  Order_By2["Asc"] = "asc";
  Order_By2["AscNullsFirst"] = "asc_nulls_first";
  Order_By2["AscNullsLast"] = "asc_nulls_last";
  Order_By2["Desc"] = "desc";
  Order_By2["DescNullsFirst"] = "desc_nulls_first";
  Order_By2["DescNullsLast"] = "desc_nulls_last";
  return Order_By2;
})(Order_By || {});
var Playlist_Constraint = /* @__PURE__ */ ((Playlist_Constraint2) => {
  Playlist_Constraint2["PlaylistPkey"] = "playlist_pkey";
  Playlist_Constraint2["PlaylistSIdKey"] = "playlist_s_id_key";
  Playlist_Constraint2["PlaylistUserIdSlugKey"] = "playlist_user_id_slug_key";
  return Playlist_Constraint2;
})(Playlist_Constraint || {});
var Playlist_Select_Column = /* @__PURE__ */ ((Playlist_Select_Column2) => {
  Playlist_Select_Column2["CreatedAt"] = "createdAt";
  Playlist_Select_Column2["Description"] = "description";
  Playlist_Select_Column2["Id"] = "id";
  Playlist_Select_Column2["Public"] = "public";
  Playlist_Select_Column2["SId"] = "sId";
  Playlist_Select_Column2["Slug"] = "slug";
  Playlist_Select_Column2["ThumbnailUrl"] = "thumbnailUrl";
  Playlist_Select_Column2["Title"] = "title";
  Playlist_Select_Column2["UpdatedAt"] = "updatedAt";
  Playlist_Select_Column2["UserId"] = "user_id";
  return Playlist_Select_Column2;
})(Playlist_Select_Column || {});
var Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = /* @__PURE__ */ ((Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2) => {
  Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["Public"] = "public";
  return Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2;
})(Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || {});
var Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = /* @__PURE__ */ ((Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2) => {
  Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["Public"] = "public";
  return Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2;
})(Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || {});
var Playlist_Update_Column = /* @__PURE__ */ ((Playlist_Update_Column2) => {
  Playlist_Update_Column2["CreatedAt"] = "createdAt";
  Playlist_Update_Column2["Description"] = "description";
  Playlist_Update_Column2["Id"] = "id";
  Playlist_Update_Column2["Public"] = "public";
  Playlist_Update_Column2["SId"] = "sId";
  Playlist_Update_Column2["Slug"] = "slug";
  Playlist_Update_Column2["ThumbnailUrl"] = "thumbnailUrl";
  Playlist_Update_Column2["Title"] = "title";
  Playlist_Update_Column2["UpdatedAt"] = "updatedAt";
  Playlist_Update_Column2["UserId"] = "user_id";
  return Playlist_Update_Column2;
})(Playlist_Update_Column || {});
var Playlist_Videos_Constraint = /* @__PURE__ */ ((Playlist_Videos_Constraint2) => {
  Playlist_Videos_Constraint2["PlaylistVideosPkey"] = "playlist_videos_pkey";
  return Playlist_Videos_Constraint2;
})(Playlist_Videos_Constraint || {});
var Playlist_Videos_Select_Column = /* @__PURE__ */ ((Playlist_Videos_Select_Column2) => {
  Playlist_Videos_Select_Column2["CreatedAt"] = "createdAt";
  Playlist_Videos_Select_Column2["PlaylistId"] = "playlist_id";
  Playlist_Videos_Select_Column2["Position"] = "position";
  Playlist_Videos_Select_Column2["UpdatedAt"] = "updatedAt";
  Playlist_Videos_Select_Column2["VideoId"] = "video_id";
  return Playlist_Videos_Select_Column2;
})(Playlist_Videos_Select_Column || {});
var Playlist_Videos_Update_Column = /* @__PURE__ */ ((Playlist_Videos_Update_Column2) => {
  Playlist_Videos_Update_Column2["CreatedAt"] = "createdAt";
  Playlist_Videos_Update_Column2["PlaylistId"] = "playlist_id";
  Playlist_Videos_Update_Column2["Position"] = "position";
  Playlist_Videos_Update_Column2["UpdatedAt"] = "updatedAt";
  Playlist_Videos_Update_Column2["VideoId"] = "video_id";
  return Playlist_Videos_Update_Column2;
})(Playlist_Videos_Update_Column || {});
var Posts_Constraint = /* @__PURE__ */ ((Posts_Constraint2) => {
  Posts_Constraint2["PostsPkey"] = "posts_pkey";
  Posts_Constraint2["PostsSlugKey"] = "posts_slug_key";
  return Posts_Constraint2;
})(Posts_Constraint || {});
var Posts_Select_Column = /* @__PURE__ */ ((Posts_Select_Column2) => {
  Posts_Select_Column2["Brief"] = "brief";
  Posts_Select_Column2["CreatedAt"] = "created_at";
  Posts_Select_Column2["HId"] = "hId";
  Posts_Select_Column2["Id"] = "id";
  Posts_Select_Column2["MarkdownContent"] = "markdownContent";
  Posts_Select_Column2["ReadTimeInMinutes"] = "readTimeInMinutes";
  Posts_Select_Column2["Slug"] = "slug";
  Posts_Select_Column2["Title"] = "title";
  Posts_Select_Column2["UpdatedAt"] = "updated_at";
  return Posts_Select_Column2;
})(Posts_Select_Column || {});
var Posts_Update_Column = /* @__PURE__ */ ((Posts_Update_Column2) => {
  Posts_Update_Column2["Brief"] = "brief";
  Posts_Update_Column2["CreatedAt"] = "created_at";
  Posts_Update_Column2["HId"] = "hId";
  Posts_Update_Column2["Id"] = "id";
  Posts_Update_Column2["MarkdownContent"] = "markdownContent";
  Posts_Update_Column2["ReadTimeInMinutes"] = "readTimeInMinutes";
  Posts_Update_Column2["Slug"] = "slug";
  Posts_Update_Column2["Title"] = "title";
  Posts_Update_Column2["UpdatedAt"] = "updated_at";
  return Posts_Update_Column2;
})(Posts_Update_Column || {});
var Subtitles_Constraint = /* @__PURE__ */ ((Subtitles_Constraint2) => {
  Subtitles_Constraint2["SubtitlesPkey"] = "subtitles_pkey";
  return Subtitles_Constraint2;
})(Subtitles_Constraint || {});
var Subtitles_Select_Column = /* @__PURE__ */ ((Subtitles_Select_Column2) => {
  Subtitles_Select_Column2["CreatedAt"] = "created_at";
  Subtitles_Select_Column2["Id"] = "id";
  Subtitles_Select_Column2["IsDefault"] = "isDefault";
  Subtitles_Select_Column2["Lang"] = "lang";
  Subtitles_Select_Column2["UpdatedAt"] = "updated_at";
  Subtitles_Select_Column2["Url"] = "url";
  Subtitles_Select_Column2["VideoId"] = "video_id";
  return Subtitles_Select_Column2;
})(Subtitles_Select_Column || {});
var Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = /* @__PURE__ */ ((Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2) => {
  Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["IsDefault"] = "isDefault";
  return Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2;
})(Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || {});
var Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = /* @__PURE__ */ ((Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2) => {
  Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["IsDefault"] = "isDefault";
  return Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2;
})(Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || {});
var Subtitles_Update_Column = /* @__PURE__ */ ((Subtitles_Update_Column2) => {
  Subtitles_Update_Column2["CreatedAt"] = "created_at";
  Subtitles_Update_Column2["Id"] = "id";
  Subtitles_Update_Column2["IsDefault"] = "isDefault";
  Subtitles_Update_Column2["Lang"] = "lang";
  Subtitles_Update_Column2["UpdatedAt"] = "updated_at";
  Subtitles_Update_Column2["Url"] = "url";
  Subtitles_Update_Column2["VideoId"] = "video_id";
  return Subtitles_Update_Column2;
})(Subtitles_Update_Column || {});
var Tags_Constraint = /* @__PURE__ */ ((Tags_Constraint2) => {
  Tags_Constraint2["TagsPkey"] = "tags_pkey";
  Tags_Constraint2["TagsSlugSiteKey"] = "tags_slug_site_key";
  return Tags_Constraint2;
})(Tags_Constraint || {});
var Tags_Select_Column = /* @__PURE__ */ ((Tags_Select_Column2) => {
  Tags_Select_Column2["CreatedAt"] = "created_at";
  Tags_Select_Column2["Description"] = "description";
  Tags_Select_Column2["DisplayOrder"] = "display_order";
  Tags_Select_Column2["Id"] = "id";
  Tags_Select_Column2["Name"] = "name";
  Tags_Select_Column2["Site"] = "site";
  Tags_Select_Column2["Slug"] = "slug";
  Tags_Select_Column2["UpdatedAt"] = "updated_at";
  return Tags_Select_Column2;
})(Tags_Select_Column || {});
var Tags_Update_Column = /* @__PURE__ */ ((Tags_Update_Column2) => {
  Tags_Update_Column2["CreatedAt"] = "created_at";
  Tags_Update_Column2["Description"] = "description";
  Tags_Update_Column2["DisplayOrder"] = "display_order";
  Tags_Update_Column2["Id"] = "id";
  Tags_Update_Column2["Name"] = "name";
  Tags_Update_Column2["Site"] = "site";
  Tags_Update_Column2["Slug"] = "slug";
  Tags_Update_Column2["UpdatedAt"] = "updated_at";
  return Tags_Update_Column2;
})(Tags_Update_Column || {});
var Tasks_Constraint = /* @__PURE__ */ ((Tasks_Constraint2) => {
  Tasks_Constraint2["TasksEntityTypeEntityIdTypeKey"] = "tasks_entity_type_entity_id_type_key";
  Tasks_Constraint2["TasksPkey"] = "tasks_pkey";
  Tasks_Constraint2["TasksTaskIdKey"] = "tasks_task_id_key";
  return Tasks_Constraint2;
})(Tasks_Constraint || {});
var Tasks_Select_Column = /* @__PURE__ */ ((Tasks_Select_Column2) => {
  Tasks_Select_Column2["Completed"] = "completed";
  Tasks_Select_Column2["CreatedAt"] = "created_at";
  Tasks_Select_Column2["EntityId"] = "entity_id";
  Tasks_Select_Column2["EntityType"] = "entity_type";
  Tasks_Select_Column2["Id"] = "id";
  Tasks_Select_Column2["Metadata"] = "metadata";
  Tasks_Select_Column2["Status"] = "status";
  Tasks_Select_Column2["TaskId"] = "task_id";
  Tasks_Select_Column2["Type"] = "type";
  Tasks_Select_Column2["UpdatedAt"] = "updated_at";
  return Tasks_Select_Column2;
})(Tasks_Select_Column || {});
var Tasks_Update_Column = /* @__PURE__ */ ((Tasks_Update_Column2) => {
  Tasks_Update_Column2["Completed"] = "completed";
  Tasks_Update_Column2["CreatedAt"] = "created_at";
  Tasks_Update_Column2["EntityId"] = "entity_id";
  Tasks_Update_Column2["EntityType"] = "entity_type";
  Tasks_Update_Column2["Id"] = "id";
  Tasks_Update_Column2["Metadata"] = "metadata";
  Tasks_Update_Column2["Status"] = "status";
  Tasks_Update_Column2["TaskId"] = "task_id";
  Tasks_Update_Column2["Type"] = "type";
  Tasks_Update_Column2["UpdatedAt"] = "updated_at";
  return Tasks_Update_Column2;
})(Tasks_Update_Column || {});
var Test_Constraint = /* @__PURE__ */ ((Test_Constraint2) => {
  Test_Constraint2["TestPkey"] = "test_pkey";
  return Test_Constraint2;
})(Test_Constraint || {});
var Test_Select_Column = /* @__PURE__ */ ((Test_Select_Column2) => {
  Test_Select_Column2["Description"] = "description";
  Test_Select_Column2["Id"] = "id";
  return Test_Select_Column2;
})(Test_Select_Column || {});
var Test_Update_Column = /* @__PURE__ */ ((Test_Update_Column2) => {
  Test_Update_Column2["Description"] = "description";
  Test_Update_Column2["Id"] = "id";
  return Test_Update_Column2;
})(Test_Update_Column || {});
var User_Video_History_Constraint = /* @__PURE__ */ ((User_Video_History_Constraint2) => {
  User_Video_History_Constraint2["UserVideoHistoryPkey"] = "user_video_history_pkey";
  User_Video_History_Constraint2["UserVideoHistoryUserIdVideoIdKey"] = "user_video_history_user_id_video_id_key";
  return User_Video_History_Constraint2;
})(User_Video_History_Constraint || {});
var User_Video_History_Select_Column = /* @__PURE__ */ ((User_Video_History_Select_Column2) => {
  User_Video_History_Select_Column2["CreatedAt"] = "created_at";
  User_Video_History_Select_Column2["Id"] = "id";
  User_Video_History_Select_Column2["LastWatchedAt"] = "last_watched_at";
  User_Video_History_Select_Column2["ProgressSeconds"] = "progress_seconds";
  User_Video_History_Select_Column2["UpdatedAt"] = "updated_at";
  User_Video_History_Select_Column2["UserId"] = "user_id";
  User_Video_History_Select_Column2["VideoId"] = "video_id";
  return User_Video_History_Select_Column2;
})(User_Video_History_Select_Column || {});
var User_Video_History_Update_Column = /* @__PURE__ */ ((User_Video_History_Update_Column2) => {
  User_Video_History_Update_Column2["CreatedAt"] = "created_at";
  User_Video_History_Update_Column2["Id"] = "id";
  User_Video_History_Update_Column2["LastWatchedAt"] = "last_watched_at";
  User_Video_History_Update_Column2["ProgressSeconds"] = "progress_seconds";
  User_Video_History_Update_Column2["UpdatedAt"] = "updated_at";
  User_Video_History_Update_Column2["UserId"] = "user_id";
  User_Video_History_Update_Column2["VideoId"] = "video_id";
  return User_Video_History_Update_Column2;
})(User_Video_History_Update_Column || {});
var Users_Constraint = /* @__PURE__ */ ((Users_Constraint2) => {
  Users_Constraint2["UsersAuth0IdKey"] = "users_auth0_id_key";
  Users_Constraint2["UsersEmailKey"] = "users_email_key";
  Users_Constraint2["UsersPkey"] = "users_pkey";
  Users_Constraint2["UsersUsernameKey"] = "users_username_key";
  return Users_Constraint2;
})(Users_Constraint || {});
var Users_Select_Column = /* @__PURE__ */ ((Users_Select_Column2) => {
  Users_Select_Column2["Auth0Id"] = "auth0_id";
  Users_Select_Column2["CreatedAt"] = "created_at";
  Users_Select_Column2["Email"] = "email";
  Users_Select_Column2["Id"] = "id";
  Users_Select_Column2["UpdatedAt"] = "updated_at";
  Users_Select_Column2["Username"] = "username";
  return Users_Select_Column2;
})(Users_Select_Column || {});
var Users_Update_Column = /* @__PURE__ */ ((Users_Update_Column2) => {
  Users_Update_Column2["Auth0Id"] = "auth0_id";
  Users_Update_Column2["CreatedAt"] = "created_at";
  Users_Update_Column2["Email"] = "email";
  Users_Update_Column2["Id"] = "id";
  Users_Update_Column2["UpdatedAt"] = "updated_at";
  Users_Update_Column2["Username"] = "username";
  return Users_Update_Column2;
})(Users_Update_Column || {});
var Video_Tags_Constraint = /* @__PURE__ */ ((Video_Tags_Constraint2) => {
  Video_Tags_Constraint2["VideoTagsPkey"] = "video_tags_pkey";
  return Video_Tags_Constraint2;
})(Video_Tags_Constraint || {});
var Video_Tags_Select_Column = /* @__PURE__ */ ((Video_Tags_Select_Column2) => {
  Video_Tags_Select_Column2["CreatedAt"] = "created_at";
  Video_Tags_Select_Column2["TagId"] = "tag_id";
  Video_Tags_Select_Column2["UpdatedAt"] = "updated_at";
  Video_Tags_Select_Column2["VideoId"] = "video_id";
  return Video_Tags_Select_Column2;
})(Video_Tags_Select_Column || {});
var Video_Tags_Update_Column = /* @__PURE__ */ ((Video_Tags_Update_Column2) => {
  Video_Tags_Update_Column2["CreatedAt"] = "created_at";
  Video_Tags_Update_Column2["TagId"] = "tag_id";
  Video_Tags_Update_Column2["UpdatedAt"] = "updated_at";
  Video_Tags_Update_Column2["VideoId"] = "video_id";
  return Video_Tags_Update_Column2;
})(Video_Tags_Update_Column || {});
var Video_Views_Constraint = /* @__PURE__ */ ((Video_Views_Constraint2) => {
  Video_Views_Constraint2["VideoViewsPkey"] = "video_views_pkey";
  return Video_Views_Constraint2;
})(Video_Views_Constraint || {});
var Video_Views_Select_Column = /* @__PURE__ */ ((Video_Views_Select_Column2) => {
  Video_Views_Select_Column2["Id"] = "id";
  Video_Views_Select_Column2["UserId"] = "user_id";
  Video_Views_Select_Column2["VideoId"] = "video_id";
  Video_Views_Select_Column2["ViewedAt"] = "viewed_at";
  return Video_Views_Select_Column2;
})(Video_Views_Select_Column || {});
var Video_Views_Update_Column = /* @__PURE__ */ ((Video_Views_Update_Column2) => {
  Video_Views_Update_Column2["Id"] = "id";
  Video_Views_Update_Column2["UserId"] = "user_id";
  Video_Views_Update_Column2["VideoId"] = "video_id";
  Video_Views_Update_Column2["ViewedAt"] = "viewed_at";
  return Video_Views_Update_Column2;
})(Video_Views_Update_Column || {});
var Videos_Constraint = /* @__PURE__ */ ((Videos_Constraint2) => {
  Videos_Constraint2["VideosPkey"] = "videos_pkey";
  Videos_Constraint2["VideosSIdKey"] = "videos_s_id_key";
  Videos_Constraint2["VideosSlugUnique"] = "videos_slug_unique";
  return Videos_Constraint2;
})(Videos_Constraint || {});
var Videos_Select_Column = /* @__PURE__ */ ((Videos_Select_Column2) => {
  Videos_Select_Column2["CreatedAt"] = "createdAt";
  Videos_Select_Column2["Description"] = "description";
  Videos_Select_Column2["Duration"] = "duration";
  Videos_Select_Column2["Id"] = "id";
  Videos_Select_Column2["KeepOriginalSource"] = "keepOriginalSource";
  Videos_Select_Column2["Public"] = "public";
  Videos_Select_Column2["SId"] = "sId";
  Videos_Select_Column2["SkipProcess"] = "skip_process";
  Videos_Select_Column2["Slug"] = "slug";
  Videos_Select_Column2["Source"] = "source";
  Videos_Select_Column2["Status"] = "status";
  Videos_Select_Column2["ThumbnailUrl"] = "thumbnailUrl";
  Videos_Select_Column2["Title"] = "title";
  Videos_Select_Column2["UpdatedAt"] = "updatedAt";
  Videos_Select_Column2["UserId"] = "user_id";
  Videos_Select_Column2["VideoUrl"] = "video_url";
  Videos_Select_Column2["ViewCount"] = "view_count";
  return Videos_Select_Column2;
})(Videos_Select_Column || {});
var Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns = /* @__PURE__ */ ((Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2) => {
  Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["KeepOriginalSource"] = "keepOriginalSource";
  Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["Public"] = "public";
  Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2["SkipProcess"] = "skip_process";
  return Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns2;
})(Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns || {});
var Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns = /* @__PURE__ */ ((Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2) => {
  Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["KeepOriginalSource"] = "keepOriginalSource";
  Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["Public"] = "public";
  Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2["SkipProcess"] = "skip_process";
  return Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns2;
})(Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns || {});
var Videos_Update_Column = /* @__PURE__ */ ((Videos_Update_Column2) => {
  Videos_Update_Column2["CreatedAt"] = "createdAt";
  Videos_Update_Column2["Description"] = "description";
  Videos_Update_Column2["Duration"] = "duration";
  Videos_Update_Column2["Id"] = "id";
  Videos_Update_Column2["KeepOriginalSource"] = "keepOriginalSource";
  Videos_Update_Column2["Public"] = "public";
  Videos_Update_Column2["SId"] = "sId";
  Videos_Update_Column2["SkipProcess"] = "skip_process";
  Videos_Update_Column2["Slug"] = "slug";
  Videos_Update_Column2["Source"] = "source";
  Videos_Update_Column2["Status"] = "status";
  Videos_Update_Column2["ThumbnailUrl"] = "thumbnailUrl";
  Videos_Update_Column2["Title"] = "title";
  Videos_Update_Column2["UpdatedAt"] = "updatedAt";
  Videos_Update_Column2["UserId"] = "user_id";
  Videos_Update_Column2["VideoUrl"] = "video_url";
  Videos_Update_Column2["ViewCount"] = "view_count";
  return Videos_Update_Column2;
})(Videos_Update_Column || {});
var TypedDocumentString = class extends String {
  constructor(value, __meta__) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }
  toString() {
    return this.value;
  }
};
var UserFieldsFragmentDoc = new TypedDocumentString(`
    fragment UserFields on users {
  username
}
    `, { "fragmentName": "UserFields" });
var VideoFieldsFragmentDoc = new TypedDocumentString(`
    fragment VideoFields on videos {
  id
  title
  description
  duration
  thumbnailUrl
  source
  slug
  createdAt
  user {
    ...UserFields
  }
  user_video_histories {
    last_watched_at
    progress_seconds
  }
  subtitles {
    id
    isDefault
    lang
    url
  }
}
    fragment UserFields on users {
  username
}`, { "fragmentName": "VideoFields" });
var PlaylistVideoFieldsFragmentDoc = new TypedDocumentString(`
    fragment PlaylistVideoFields on playlist_videos {
  position
  video {
    ...VideoFields
  }
}
    fragment UserFields on users {
  username
}
fragment VideoFields on videos {
  id
  title
  description
  duration
  thumbnailUrl
  source
  slug
  createdAt
  user {
    ...UserFields
  }
  user_video_histories {
    last_watched_at
    progress_seconds
  }
  subtitles {
    id
    isDefault
    lang
    url
  }
}`, { "fragmentName": "PlaylistVideoFields" });
var PlaylistFieldsFragmentDoc = new TypedDocumentString(`
    fragment PlaylistFields on playlist {
  id
  title
  thumbnailUrl
  slug
  createdAt
  description
  user {
    ...UserFields
  }
  playlist_videos(
    where: {video: {status: {_eq: "ready"}}}
    order_by: {position: asc}
  ) {
    ...PlaylistVideoFields
  }
}
    fragment UserFields on users {
  username
}
fragment VideoFields on videos {
  id
  title
  description
  duration
  thumbnailUrl
  source
  slug
  createdAt
  user {
    ...UserFields
  }
  user_video_histories {
    last_watched_at
    progress_seconds
  }
  subtitles {
    id
    isDefault
    lang
    url
  }
}
fragment PlaylistVideoFields on playlist_videos {
  position
  video {
    ...VideoFields
  }
}`, { "fragmentName": "PlaylistFields" });
var CreateFinanceRecordDocument = new TypedDocumentString(`
    mutation CreateFinanceRecord($object: finance_transactions_insert_input!) {
  insert_finance_transactions_one(object: $object) {
    id
    name
    amount
    month
    year
    category
    createdAt
  }
}
    `);
var UpdateFinanceRecordDocument = new TypedDocumentString(`
    mutation UpdateFinanceRecord($id: uuid!, $object: finance_transactions_set_input!) {
  update_finance_transactions_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    name
    amount
    month
    year
    category
    updatedAt
  }
}
    `);
var DeleteFinanceRecordDocument = new TypedDocumentString(`
    mutation DeleteFinanceRecord($id: uuid!) {
  delete_finance_transactions_by_pk(id: $id) {
    id
  }
}
    `);
var GetFinanceRecordsDocument = new TypedDocumentString(`
    query GetFinanceRecords($month: Int!, $year: Int!) {
  finance_transactions(
    where: {month: {_eq: $month}, year: {_eq: $year}}
    order_by: {createdAt: desc}
  ) {
    id
    name
    amount
    month
    year
    category
    createdAt
    updatedAt
  }
  must_aggregate: finance_transactions_aggregate(
    where: {month: {_eq: $month}, year: {_eq: $year}, category: {_eq: "must"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  nice_aggregate: finance_transactions_aggregate(
    where: {month: {_eq: $month}, year: {_eq: $year}, category: {_eq: "nice"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  waste_aggregate: finance_transactions_aggregate(
    where: {month: {_eq: $month}, year: {_eq: $year}, category: {_eq: "waste"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  oldest_aggregate: finance_transactions(
    order_by: {year: asc, month: asc}
    limit: 1
  ) {
    year
    month
  }
}
    `);
var GetMonthlyComparisonDocument = new TypedDocumentString(`
    query GetMonthlyComparison {
  monthly_totals: finance_transactions_aggregate(
    order_by: {year: desc, month: desc}
  ) {
    nodes {
      month
      year
    }
    aggregate {
      sum {
        amount
      }
      count
    }
  }
}
    `);
var CreateJournalDocument = new TypedDocumentString(`
    mutation CreateJournal($object: journals_insert_input!) {
  insert_journals_one(object: $object) {
    id
    date
    content
    mood
    tags
    createdAt
    updatedAt
  }
}
    `);
var UpdateJournalDocument = new TypedDocumentString(`
    mutation UpdateJournal($id: uuid!, $set: journals_set_input!) {
  update_journals_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    date
    content
    mood
    tags
    updatedAt
  }
}
    `);
var DeleteJournalDocument = new TypedDocumentString(`
    mutation DeleteJournal($id: uuid!) {
  delete_journals_by_pk(id: $id) {
    id
    date
  }
}
    `);
var GetJournalsByMonthDocument = new TypedDocumentString(`
    query GetJournalsByMonth($startDate: date!, $endDate: date!) {
  journals(
    where: {date: {_gte: $startDate, _lte: $endDate}}
    order_by: {date: desc, createdAt: desc}
  ) {
    id
    user_id
    date
    content
    mood
    tags
    createdAt
    updatedAt
  }
  happy_aggregate: journals_aggregate(
    where: {date: {_gte: $startDate, _lte: $endDate}, mood: {_eq: "happy"}}
  ) {
    aggregate {
      count
    }
  }
  neutral_aggregate: journals_aggregate(
    where: {date: {_gte: $startDate, _lte: $endDate}, mood: {_eq: "neutral"}}
  ) {
    aggregate {
      count
    }
  }
  sad_aggregate: journals_aggregate(
    where: {date: {_gte: $startDate, _lte: $endDate}, mood: {_eq: "sad"}}
  ) {
    aggregate {
      count
    }
  }
  oldest_aggregate: journals(order_by: {date: asc}, limit: 1) {
    date
  }
}
    `);
var GetJournalByIdDocument = new TypedDocumentString(`
    query GetJournalById($id: uuid!) {
  journals_by_pk(id: $id) {
    id
    user_id
    date
    content
    mood
    tags
    createdAt
    updatedAt
  }
}
    `);
var GetAudiosAndFeelingsDocument = new TypedDocumentString(`
    query GetAudiosAndFeelings @cached {
  audios {
    id
    name
    source
    thumbnailUrl
    public
    artistName
    createdAt
    audio_tags {
      tag_id
    }
  }
  tags(where: {site: {_eq: "listen"}}) {
    id
    name
  }
}
    `);
var GetPublicAudiosAndFeelingsDocument = new TypedDocumentString(`
    query GetPublicAudiosAndFeelings @cached {
  audios(where: {public: {_eq: true}}) {
    id
    name
    source
    thumbnailUrl
    artistName
    audio_tags {
      tag_id
    }
  }
  tags(where: {site: {_eq: "listen"}, audio_tags: {audio: {public: {_eq: true}}}}) {
    id
    name
  }
}
    `);
var PostDocument = new TypedDocumentString(`
    query Post($id: uuid!) @cached {
  posts_by_pk(id: $id) {
    title
    readTimeInMinutes
    markdownContent
    id
    brief
    slug
  }
}
    `);
var AllPostsDocument = new TypedDocumentString(`
    query AllPosts @cached {
  posts(order_by: {slug: desc}) {
    brief
    id
    markdownContent
    readTimeInMinutes
    title
    slug
  }
}
    `);
var FeatureFlagsDocument = new TypedDocumentString(`
    subscription FeatureFlags {
  feature_flag {
    id
    name
    conditions
  }
}
    `);
var MarkNotificationAsReadDocument = new TypedDocumentString(`
    mutation MarkNotificationAsRead($notificationId: uuid!) {
  update_notifications_by_pk(
    pk_columns: {id: $notificationId}
    _set: {readAt: "now()"}
  ) {
    id
    readAt
  }
}
    `);
var MarkNotificationsAsReadDocument = new TypedDocumentString(`
    mutation MarkNotificationsAsRead($ids: [uuid!]!) {
  update_notifications(
    where: {id: {_in: $ids}, readAt: {_is_null: true}}
    _set: {readAt: "now()"}
  ) {
    affected_rows
    returning {
      id
      readAt
    }
  }
}
    `);
var NotificationsDocument = new TypedDocumentString(`
    subscription Notifications {
  notifications(order_by: {createdAt: desc}) {
    id
    entityId
    entityType
    type
    readAt
    link
    metadata
    video {
      id
      title
    }
  }
}
    `);
var InsertVideosDocument = new TypedDocumentString(`
    mutation InsertVideos($objects: [videos_insert_input!]!) {
  insert_videos(objects: $objects) {
    returning {
      id
      title
      description
    }
  }
}
    `);
var UpdateVideoProgressDocument = new TypedDocumentString(`
    mutation UpdateVideoProgress($videoId: uuid!, $progressSeconds: Int!, $lastWatchedAt: timestamptz!) {
  insert_user_video_history_one(
    object: {video_id: $videoId, progress_seconds: $progressSeconds, last_watched_at: $lastWatchedAt}
    on_conflict: {constraint: user_video_history_user_id_video_id_key, update_columns: [progress_seconds, last_watched_at]}
  ) {
    id
    progress_seconds
    last_watched_at
  }
}
    `);
var UserVideoHistoryDocument = new TypedDocumentString(`
    query UserVideoHistory {
  user_video_history(
    where: {_and: {last_watched_at: {_is_null: false}, progress_seconds: {_gt: 0}, video: {source: {_is_null: false}}}}
    order_by: {last_watched_at: desc}
  ) {
    id
    last_watched_at
    progress_seconds
    video {
      id
      title
      source
      slug
      thumbnailUrl
      duration
      createdAt
      user {
        ...UserFields
      }
      playlist_videos {
        playlist {
          id
          slug
          title
          thumbnailUrl
        }
      }
    }
  }
}
    fragment UserFields on users {
  username
}`);
var PlaylistDetailDocument = new TypedDocumentString(`
    query PlaylistDetail($id: uuid!) {
  playlist_by_pk(id: $id) {
    ...PlaylistFields
  }
}
    fragment UserFields on users {
  username
}
fragment VideoFields on videos {
  id
  title
  description
  duration
  thumbnailUrl
  source
  slug
  createdAt
  user {
    ...UserFields
  }
  user_video_histories {
    last_watched_at
    progress_seconds
  }
  subtitles {
    id
    isDefault
    lang
    url
  }
}
fragment PlaylistVideoFields on playlist_videos {
  position
  video {
    ...VideoFields
  }
}
fragment PlaylistFields on playlist {
  id
  title
  thumbnailUrl
  slug
  createdAt
  description
  user {
    ...UserFields
  }
  playlist_videos(
    where: {video: {status: {_eq: "ready"}}}
    order_by: {position: asc}
  ) {
    ...PlaylistVideoFields
  }
}`);
var PlaylistsDocument = new TypedDocumentString(`
    query Playlists {
  playlist(order_by: {createdAt: desc}) {
    title
    id
    slug
  }
}
    `);
var VideoDetailDocument = new TypedDocumentString(`
    query VideoDetail($id: uuid!) @cached {
  videos(
    where: {_and: {_not: {playlist_videos: {}}, status: {_eq: "ready"}}}
    order_by: {createdAt: desc}
  ) {
    ...VideoFields
  }
  videos_by_pk(id: $id) {
    id
    source
    thumbnailUrl
    title
    description
  }
}
    fragment UserFields on users {
  username
}
fragment VideoFields on videos {
  id
  title
  description
  duration
  thumbnailUrl
  source
  slug
  createdAt
  user {
    ...UserFields
  }
  user_video_histories {
    last_watched_at
    progress_seconds
  }
  subtitles {
    id
    isDefault
    lang
    url
  }
}`);
var AllVideosDocument = new TypedDocumentString(`
    query AllVideos @cached {
  videos(
    where: {_and: {_not: {playlist_videos: {}}, status: {_eq: "ready"}}}
    order_by: {createdAt: desc}
  ) {
    ...VideoFields
  }
  playlist(
    where: {playlist_videos_aggregate: {count: {predicate: {_gt: 0}, filter: {video: {status: {_eq: "ready"}}}}}}
  ) {
    ...PlaylistFields
  }
}
    fragment UserFields on users {
  username
}
fragment VideoFields on videos {
  id
  title
  description
  duration
  thumbnailUrl
  source
  slug
  createdAt
  user {
    ...UserFields
  }
  user_video_histories {
    last_watched_at
    progress_seconds
  }
  subtitles {
    id
    isDefault
    lang
    url
  }
}
fragment PlaylistVideoFields on playlist_videos {
  position
  video {
    ...VideoFields
  }
}
fragment PlaylistFields on playlist {
  id
  title
  thumbnailUrl
  slug
  createdAt
  description
  user {
    ...UserFields
  }
  playlist_videos(
    where: {video: {status: {_eq: "ready"}}}
    order_by: {position: asc}
  ) {
    ...PlaylistVideoFields
  }
}`);

export { AllPostsDocument, AllVideosDocument, Audio_Tags_Constraint, Audio_Tags_Select_Column, Audio_Tags_Update_Column, Audios_Constraint, Audios_Select_Column, Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_And_Arguments_Columns, Audios_Select_Column_Audios_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns, Audios_Update_Column, Crawl_Requests_Constraint, Crawl_Requests_Select_Column, Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_And_Arguments_Columns, Crawl_Requests_Select_Column_Crawl_Requests_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns, Crawl_Requests_Update_Column, CreateFinanceRecordDocument, CreateJournalDocument, Cursor_Ordering, DeleteFinanceRecordDocument, DeleteJournalDocument, FeatureFlagsDocument, Feature_Flag_Constraint, Feature_Flag_Select_Column, Feature_Flag_Update_Column, Finance_Transactions_Constraint, Finance_Transactions_Select_Column, Finance_Transactions_Update_Column, GetAudiosAndFeelingsDocument, GetFinanceRecordsDocument, GetJournalByIdDocument, GetJournalsByMonthDocument, GetMonthlyComparisonDocument, GetPublicAudiosAndFeelingsDocument, InsertVideosDocument, Journals_Constraint, Journals_Select_Column, Journals_Update_Column, MarkNotificationAsReadDocument, MarkNotificationsAsReadDocument, NotificationsDocument, Notifications_Constraint, Notifications_Select_Column, Notifications_Update_Column, Order_By, PlaylistDetailDocument, PlaylistFieldsFragmentDoc, PlaylistVideoFieldsFragmentDoc, Playlist_Constraint, Playlist_Select_Column, Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns, Playlist_Select_Column_Playlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns, Playlist_Update_Column, Playlist_Videos_Constraint, Playlist_Videos_Select_Column, Playlist_Videos_Update_Column, PlaylistsDocument, PostDocument, Posts_Constraint, Posts_Select_Column, Posts_Update_Column, Subtitles_Constraint, Subtitles_Select_Column, Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_And_Arguments_Columns, Subtitles_Select_Column_Subtitles_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns, Subtitles_Update_Column, Tags_Constraint, Tags_Select_Column, Tags_Update_Column, Tasks_Constraint, Tasks_Select_Column, Tasks_Update_Column, Test_Constraint, Test_Select_Column, Test_Update_Column, TypedDocumentString, UpdateFinanceRecordDocument, UpdateJournalDocument, UpdateVideoProgressDocument, UserFieldsFragmentDoc, UserVideoHistoryDocument, User_Video_History_Constraint, User_Video_History_Select_Column, User_Video_History_Update_Column, Users_Constraint, Users_Select_Column, Users_Update_Column, VideoDetailDocument, VideoFieldsFragmentDoc, Video_Tags_Constraint, Video_Tags_Select_Column, Video_Tags_Update_Column, Video_Views_Constraint, Video_Views_Select_Column, Video_Views_Update_Column, Videos_Constraint, Videos_Select_Column, Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_And_Arguments_Columns, Videos_Select_Column_Videos_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns, Videos_Update_Column };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-GRW5ATLE.mjs.map